import { install } from './helper';
var env = {
    mode: 'staging',
    baseApi: '//api-test.aquanliang.com',
    domain: 'www-test.aquanliang.com',
    assetsDomain: 'www-test.aquanliang.com',
};
export default install(env);
